import axios from 'axios'
import qs from 'qs'
// import vConsole from '../vconsole'

// 创建axios实例
const instance = axios.create({
  timeout: 5000 // 请求超时时间
})

instance.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8' // 'application/json';
instance.defaults.baseURL = process.env.NODE_ENV == 'production' ? 'https://api.compassedu.hk/index.php/api/' : 'http://118.24.185.42:880/api/'
const base_api = process.env.NODE_ENV  == 'production' ? 'https://api.compassedu.hk/index.php/api/' : 'https://testapi.compassedu.hk/index.php/api/'
console.log(`当前环境变量：${process.env.NODE_ENV}，接口前缀 -- base_api -- ${base_api}, instance.defaults.baseURL -- ${instance.defaults.baseURL}`)
if (process.env.NODE_ENV != 'production') {
  // vConsole
  // alert(`当前环境：${process.env.NODE_ENV}，接口前缀 -- base_api -- ${base_api}, instance.defaults.baseURL -- ${instance.defaults.baseURL}`)
}

// request拦截器
instance.interceptors.request.use(
  config => {
    if (config.method === 'post') {
      config.data = qs.stringify(config.data)
    }
    console.log('方法:', config.method)
    console.log('接口:', config.url)
    console.log('参数:', config.data || 'null')
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// response 拦截器
instance.interceptors.response.use(
  res => {
    console.log('服务器返回:', res.data)
    if (res.status === 200) {
      if (res.data.code == 0) {
        return Promise.resolve(res.data)
      } else {
        return Promise.reject(res.data)
      }
    } else {
      return Promise.reject(res)
    }
  },
  error => {
    console.log('服务器error:', error)
    return Promise.reject(error)
  }
)

export default {
  getChannelInfo(code) {
    return instance.post(
      base_api + 'clue/channelinfo',
      {
        code,
        sign: 'last',
        timestamp: Number(new Date())
      },
      {
        headers: {
          appkey: 'compassedu'
        }
      }
    )
  },
  getApplicationYears() {
    return instance.post(
      base_api + 'clue/calcyear',
      {
        sign: 'last',
        timestamp: Number(new Date())
      },
      {
        headers: {
          appkey: 'compassedu'
        }
      }
    )
  },
  getCountrys() {
    return instance.post(
      base_api + 'category/list',
      {
        parent_id: 3,
        level: 0,
        sign: 'last',
        timestamp: Number(new Date())
      },
      {
        headers: {
          appkey: 'compassedu'
        }
      }
    )
  },
  getCollegesListOrder(params) {
    return instance.post(
      base_api + 'colleges/listorder',
      {
        sign: 'last',
        timestamp: Number(new Date()),
        ...params
      },
      {
        headers: {
          appkey: 'compassedu'
        }
      }
    )
  },
  getAliRegions() {
    return instance.post(
      base_api + 'regions/list',
      {
        type: 1,
        sign: 'last',
        timestamp: Number(new Date())
      },
      {
        headers: {
          appkey: 'compassedu'
        }
      }
    )
  },
  getSchools(params) {
    return instance.post(base_api + 'colleges/list', {
      sign: 'last',
      timestamp: Number(new Date()),
      ...params
    })
  },
  addCluebym(params) {
    return instance.post(
      base_api + 'clue/addcluebym',
      {
        sign: 'last',
        timestamp: Number(new Date()),
        ...params
      },
      {
        headers: {
          appkey: 'compassedu'
        }
      }
    )
  },
  getBaseClueInfo(id,uid='') {
    return instance.post(
      base_api + 'handbook/receivefirst',
      {
        id,
        uid,
        sign: 'last',
        timestamp: Number(new Date())
      },
      {
        headers: {
          appkey: 'compassedu'
        }
      }
    )
  },
  getAreas() {
    return instance.post(
      base_api + 'v1/category/list',
      {
        parent_id: 1,
        level: 1,
        sign: 'last',
        timestamp: Number(new Date())
      },
      {
        headers: {
          appkey: 'compassedu'
        }
      }
    )
  },
  submitHandBook(data) {
    return instance.post(
      base_api + 'handbook/receivesecond',
      {
        ...data,
        sign: 'last',
        timestamp: Number(new Date())
      },
      {
        headers: {
          appkey: 'compassedu'
        }
      }
    )
  },
  getWxSign(url) {
    return instance.post(
      base_api + 'weixin/getsignpackage',
      {
        url,
        sign: 'last',
        timestamp: Number(new Date())
      },
      {
        headers: {
          appkey: 'compassedu'
        }
      }
    )
  },
  getAcode(data) {
    return instance.post(
      base_api + 'v1/app/acode',
      {
        ...data,
        sign: 'last',
        timestamp: Number(new Date())
      },
      {
        headers: {
          appkey: 'compassedu'
        }
      }
    )
  },
  getAddressSearch(data) {
    return instance.post(
      base_api + 'address/getaddresssearch',
      {
        ...data,
        sign: 'last',
        timestamp: Number(new Date())
      },
      {
        headers: {
          appkey: 'compassedu'
        }
      }
    )
  }
}
